package com.parmartechnologies.business.feature.businessConnection.network

import com.parmartechnologies.core.feature.businessConnection.event.BusinessConnectionEvent
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionCreateRequest
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionCreateResponse
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionRetrieveRequest
import com.parmartechnologies.core.feature.businessConnection.network.BusinessConnectionRetrieveResponse
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import com.parmartechnologies.core.network.rest.FriendlyClient
import com.parmartechnologies.core.constant.AppServer

class BusinessConnectionNetwork {
    val json = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
        isLenient = true
    }

    fun retrieve(
        request: BusinessConnectionRetrieveRequest,
        onResult: (BusinessConnectionRetrieveResponse?) -> Unit
    ) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val apiRoute = AppServer.shared().getRestApiEndPointFor(BusinessConnectionEvent.api,BusinessConnectionEvent.RETRIEVE)
            try {
                val response = FriendlyClient.post(apiRoute) {
                    contentType(ContentType.Application.Json)
                    setBody(request)
                }
                onResult(json.decodeFromString(response.bodyAsText()))
            } catch (t: Throwable) {
                onResult(null)
                print(t)
            }
        }
    }

    fun create(
        request: BusinessConnectionCreateRequest,
        onResult: (BusinessConnectionCreateResponse?) -> Unit
    ) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            val apiRoute = AppServer.shared().getRestApiEndPointFor(BusinessConnectionEvent.api,BusinessConnectionEvent.CREATE)
            try {
                val response = FriendlyClient.post(apiRoute) {
                    contentType(ContentType.Application.Json)
                    setBody(request)
                }
                onResult(json.decodeFromString(response.bodyAsText()))
            } catch (t: Throwable) {
                print(t)
            }
        }
    }
}
